var NCSK = NCSK || {};

NCSK.languagePicker = new function () {
    var self = this;
    this.init = function () {
        this.dropdown();
    }

    this.dropdown = function () {
        $(".select-language").click(function () {
            $(".select-language__dropdown").toggle();
        });
    };
}();